import { render, staticRenderFns } from "./conference.vue?vue&type=template&id=33585f72"
import script from "./conference.vue?vue&type=script&lang=js"
export * from "./conference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports